module.exports = __webpack_public_path__ + "img/1.affd055e.jpg";